<div class="layout-footer flex justify-content-between text-sm">
  V. {{ appVersion }}
  <div class="ms-auto">
    Powered by
    <a style="color: var(--primary-color)" href="http://www.corvallis.it">Corvallis S.r.l.</a>
  </div>
</div>
